<div>

  <!-- backend validation message -->
<!--  @if (getNgControlErrors()?.length) {
    <span [ngClass]="value ? 'select-error-value form-error-icon' : 'select-error form-error-icon'"
      [ngbTooltip]="getNgControlErrors()?.length ? errorTooltip : null" #t="ngbTooltip"
      triggers="manual" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" tooltipClass="apc-tooltip-top"
      placement="top"  triggers="hover">
      <img src="assets/ico/error-solid.svg" alt="error">
    </span>
  }
  <ng-template #errorTooltip>
    @for (error of $any(getNgControlErrors()); track error) {
      <span>
        {{error.message}} <br />
      </span>
    }
  </ng-template>-->

  <!-- if view mode instead of select show text type su value can be copy pasted -->
  @if (currentType == "text") {
    <input #input class="form-control select-text-placeholder" type="text" [value]="renderValue" [readonly]="true"
      (mouseenter)="handleSelectInputEdit()" (mouseleave)="setSelectType()" />
  }

  @if (!isObject && currentType === 'select') {
    <ng-select #select [(ngModel)]="value"
      [ngModelOptions]="{standalone: true}" [disabled]="disabled" (input)="onChange()" (change)="onChange()"
      (blur)="onTouchedFn()" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" (open)="emitSelect()"
      [placeholder]="placeholder" [loading]="loading" [items]="items" [bindLabel]="optionName"
      [attr.bindValue]="!isObject ? optionValue: null" [bindValue]="optionValue" (mouseenter)="handleSelectInputEdit()"
      (mouseleave)="setSelectType()">
      <ng-template ng-option-tmp let-option="item">
        <div class="ng-option-title">
        {{option}}</div>
      </ng-template>
    </ng-select>
  }
  @if (isObject && currentType === 'select') {
    <ng-select #select [(ngModel)]="value" [ngModelOptions]="{standalone: true}"
      [disabled]="disabled" (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()"
      (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" (open)="emitSelect()" [placeholder]="placeholder"
      [loading]="loading" [items]="items" [bindLabel]="optionName" (mouseenter)="handleSelectInputEdit()"
      (mouseleave)="setSelectType()" [class.autogeneratedSelect]="autogenerated">
      <ng-template ng-option-tmp let-option="item">
        @if (activeDescToltip) {
          <div  [ngClass]="optionDescription && optionDescription.length > 0 ? 'font-weight-medium-bold' : ''"
            (mouseover)="this.showTooltip(option)"
            (mouseout)="this.hideTooltip()"
            (mousedown)="this.hideTooltip()" class="nameType">
            <span>{{option[optionName]}}</span>
          </div>
        } @else {
          <div class="ng-option-title"
            [ngClass]="optionDescription && optionDescription.length > 0 ? 'font-weight-medium-bold' : ''">
            {{option[optionName]}}
          </div>
          @if (optionDescription && optionDescription.length > 0) {
            <div>
              @for (optionDesc of optionDescription; track optionDesc) {
                <div class="ng-select-option-description ml-1">
                  @if (option[optionDesc] !== null) {
                    <span><span>@if (!hideDescTitle) {
                      <span>{{'columnName.' + optionDesc | translate}}: </span>
                      }<em>{{option[optionDesc]}}</em></span></span>
                    }
                  </div>
                }
              </div>
            }
          }
        </ng-template>
      </ng-select>
    }
    @if (activeDescToltip) {
      <div  class="descTooltip" #descriptionTooltip>
      </div>
    }

  </div>